import HtmlToReact from 'html-to-react';
import { useSelector } from 'react-redux';

import {
  addClosingTags,
  processingList,
  changeNot
} from '../common/templateHelper';
import { listTemplate, collectionTemplate } from '../defaultTemplates';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { collection, displayType = 'List' } = props;

  const productReducer = useSelector((state) => state.product);

  let template = collection?.productTemplate || listTemplate;

  if (displayType !== 'List') {
    template = collection?.productTemplate || collectionTemplate;
  }

  const productArray =
    collection?.productIds.map((productId) => {
      const product = productReducer.data[productId];
      return product;
    }) || [];

  const count = 0;
  let newTemplate = addClosingTags(template);
  newTemplate = changeNot(newTemplate);

  return htmlToReactParser.parseWithInstructions(
    newTemplate,
    isValidNode,
    processingList(productArray, collection, displayType, count)
  );
};

export default TemplateParser;
